import React from "react";
import { useApp } from "../state/AppContext";
import { Home, HeartHandshake, Dices, Trophy } from "lucide-react";

export default function BottomNav() {
  const { screen, setScreen, user, t } = useApp();
  // Hide during onboarding welcome or if no lang chosen yet.
  // Allow rendering for public spinner visitors (no user) so they can still see the nav.
  if (screen === "welcome" || screen === "language") return null;
  // For a user-less visitor (spinner path), we still show the nav — user-only tabs
  // will bounce them to the sign-up wizard when tapped, which is intentional.
  void user;
  const NAV = [
    { key: "home", label: t("nav_home"), icon: Home, screen: "home" },
    { key: "challenges", label: t("nav_challenges"), icon: HeartHandshake, screen: "gallery" },
    { key: "activities", label: t("nav_activities"), icon: Dices, screen: "activities" },
    { key: "progress", label: t("nav_progress"), icon: Trophy, screen: "mychallenges" },
  ];
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-50 px-3 pb-3 pt-2 bg-white/90 backdrop-blur-xl border-t border-scl-border shadow-[0_-6px_20px_rgba(43,42,40,0.06)]"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around">
        {NAV.map((n) => {
          const Icon = n.icon;
          const isChallenges = n.screen === "gallery" && (screen === "gallery" || screen === "detail" || screen === "submit");
          const isProgress = n.screen === "mychallenges" && (screen === "mychallenges" || screen === "leaderboard");
          const active = screen === n.screen || isChallenges || isProgress;
          return (
            <button
              key={n.key}
              onClick={() => setScreen(n.screen)}
              data-testid={`nav-${n.key}`}
              className={`flex flex-col items-center gap-0.5 py-1.5 px-3 rounded-2xl transition-all min-h-[44px] min-w-[56px] ${active ? "text-scl-coral" : "text-scl-charcoal/60 hover:text-scl-teal"}`}
            >
              <div className={`p-2 rounded-full transition-all ${active ? "bg-scl-coral/10" : ""}`}>
                <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
              </div>
              <span className={`text-[10px] uppercase tracking-widest font-semibold ${active ? "text-scl-coral" : ""}`}>{n.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
